import styled from "styled-components";

export const ScrollContainer = styled.div`
    max-height: 200px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 8px;
        background-color: white;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: #999;
    }

    scrollbar-width: thin;
    scrollbar-color: #ccc white;
`;

export const highlightStyle = {
    backgroundColor: 'var(--color-highlight-lighter)',
    padding: '0px',
};
